/** Bank statement rule expression type */
export enum BankStatementRuleExpressionTypeEnum {
  /** Operator (logical `AND` or logical `OR`) */
  OPERATOR = 'OPERATOR',
  /** Condition (pattern to match document) */
  CONDITION = 'CONDITION',
}
